module.exports = __webpack_public_path__ + "static/e-logistic-solution-f7c96950fbbe08521d4ec91ffa587621.png";